import { Controller } from '@hotwired/stimulus';
import { isDesktop } from '../../utils/dev';
/*
 * Description
 * -------
 *
 * Shares a URL using the Web Share API (on mobile devices) or dispatches event (on desktop or if API is not available).
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Values
 * -------
 *
 * url - (required) - URL to share
 *
 * Usage
 * -------
 *
 * <div
 *   data-controller="link-share other-controller"
 *   data-action="link-share:unavailable->other-controller#action"
 *   data-link-share-url-value="http://example/com"
 * >
 *   <button data-action="click->link-share#share">
 *     Share
 *   </button>
 * </div>
 */
export class LinkShare extends Controller {
    static values = { url: String };
    async share() {
        if (isDesktop())
            return this.dispatch('unavailable');
        try {
            await navigator.share({ url: this.urlValue });
        }
        catch (error) {
            // User aborted share
            if (error instanceof Error && error.toString().includes('AbortError'))
                return;
            this.dispatch('unavailable');
        }
    }
}
